import { WorkflowComponentParamType, Provider } from '../types';
import { WorkflowComponent } from './common/workflowcomponent';
class Output extends WorkflowComponent {
    constructor() {
        super({
            name: 'native.output',
            group: 'Input/Output',
            title: 'Output',
            description: `
        This component sets the node connected to it as output for API executions of the workflow.
      `,
            starred: true
        }, [
            {
                name: 'source',
                type: WorkflowComponentParamType.InputTable,
                title: 'Source table'
            }
        ], []);
        this.supportedProviders = [
            Provider.BigQuery,
            Provider.Postgres,
            Provider.Redshift,
            Provider.Snowflake,
            Provider.DatabricksRest
        ];
    }
    async getFullCodeSnippet({ params }) {
        return {
            query: '',
            outputs: {}
        };
    }
    async getCode({}) {
        return {
            query: '',
            outputs: {}
        };
    }
}
export { Output };
